import { useExportAction } from "@/action/use-export-action";
import { kitLabel } from "@/lib/kit-label";
import { Kit } from "@/types/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExport } from "@nnr/fontawesome-sharp-light/icons/sharp/light";
import { useState } from "react";
import { Button } from "../ui/button";

type ExportKitAreaProps = {
  kit: Kit;
};

export const ExportKitArea = ({ kit }: ExportKitAreaProps) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const { exportKitBundle } = useExportAction();

  const handleExport = async () => {
    setIsDownloading(true);
    await exportKitBundle(
      `${kitLabel(kit)} - ${kit.name}`,
      { format: "docx", includeFiles: true },
      kit.uuid,
    );
    setIsDownloading(false);
  };

  return (
    <div className="flex flex-col gap-2">
      <h3 className="text-lg font-bold">Export</h3>
      <div className="flex flex-row items-center justify-between">
        <div>Download all {kitLabel(kit)} artifacts as a zip file.</div>

        <Button
          variant="outline"
          onClick={handleExport}
          disabled={isDownloading}
        >
          <FontAwesomeIcon icon={faFileExport} />{" "}
          {isDownloading ? `Exporting...` : `Export ${kitLabel(kit)}`}
        </Button>
      </div>
    </div>
  );
};
